<div class="container-fluid">

    <div class="row align-items-center login-row">
        <div class="col-md-6 col-lg-6">
            <!-- <img src="../../../assets/admin-panel/Dashboard/background.svg" alt="BP Portal"> -->
        </div>

        <div class="col-md-6 col-lg-6 login-column">

            <nz-card class="shadow-lg login-card">
                <div class="d-flex align-items-center justify-content-center m-b-30 ">
                    <h2 class="m-b-0">Welcome Back</h2>
                </div>
                <form [formGroup]="validateForm" nz-form nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()">
                    <nz-form-item>
                        <!-- <nz-form-label nzRequired nzFor="mailId">Email Id</nz-form-label> -->
                        <nz-form-control nzErrorTip="Please Enter your Mail Id!">
                            <nz-input-group [nzPrefix]="prefixUser">
                                <input autocomplete="off" id="mailId" formControlName="mailId" nz-input placeholder="Enter Mail Id" type="mail">
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="relative password-field">
                        <!-- <nz-form-label nzRequired nzFor="password">Password</nz-form-label> -->
                        <nz-form-control nzErrorTip="Please Enter your Password!">
                            <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
                                <input autocomplete="off" [type]="passwordVisible ? 'text' : 'password'" id="password" formControlName="password" nz-input placeholder="Password">
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="relative ">
                        <a (click)="showModal()" class="float-right font-size-13 text-muted" style="position:absolute; right: 0">Forget
                            Password?</a>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-control>
                            <div class="d-flex align-items-center justify-content-center mt-3">
                                <!-- <span class="font-size-13 text-muted">Don't have an account? <a class="small" [routerLink]="['/authentication/sign-up-1']"> Signup</a></span> -->
                                <button [nzLoading]="loginConfirm" nz-button nzType="primary" class="login-form-button">Log In</button>
                            </div>
                        </nz-form-control>
                    </nz-form-item>

                </form>
                <ng-template #prefixUser><i nz-icon nzType="mail"></i></ng-template>
                <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
                <ng-template #suffixTemplate>
                    <i nz-icon [nzType]="passwordVisible ? 'eye' : 'eye-invisible'" (click)="passwordVisible = !passwordVisible"></i>
                </ng-template>
            </nz-card>
            <div class="text-center">
                <p class="powered-by">Powered By <a target="_blank" href="https://www.argitsolutions.in/">Argit
                        Solutions</a></p>
            </div>

        </div>
    </div>

</div>


<!-- GET EMAIL ID MODAL STARTS -->

<nz-modal [(nzVisible)]="getMailModal" nzWidth="350px" nzTitle="Forgot Password" nzCentered (nzOnCancel)="closeModal()">
    <ng-container *nzModalContent>
        <form [formGroup]="forgotPasswordForm" nz-form nzLayout="vertical" class="" (ngSubmit)="validateEmail()">
            <nz-form-item>
                <nz-form-control nzErrorTip="Please Enter your Mail Id!">
                    <nz-input-group [nzPrefix]="prefixUser">
                        <input autocomplete="off" id="mailId" formControlName="email" nz-input placeholder="Enter Mail Id" type="mail">
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="send_otp_section">
                <nz-form-control>
                    <div class="d-flex align-items-center justify-content-center">
                        <button nzType="primary" nz-button class="login-form-button">Send OTP</button>
                    </div>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
    <ng-template class="modal_footer" *nzModalFooter></ng-template>
</nz-modal>

<!-- GET EMAIL ID MODAL ENDS -->

<!-- GET OTP MODAL STARTS -->

<nz-modal [(nzVisible)]="getOTPModal" nzWidth="350px" nzTitle="Forgot Password" nzCentered (nzOnCancel)="closeOtpModal()">
    <ng-container *nzModalContent>
        <form *ngIf="!OTPverified" nz-form nzLayout="vertical" class="">
            <div class="text-center">
                <p>Enter OTP Received in your Email</p>
            </div>
            <div class="text-center mb-3">
                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config">
                </ng-otp-input>
            </div>
            <div class="resend_section text-center ">
                <p>Don't receive the code?</p>
                <p class="resend_button">Resend It</p>
            </div>
        </form>

        <!-- GET NEW PASSWORD -->
        <form *ngIf="OTPverified" [formGroup]="confirmPasswordForm" nz-form nzLayout="vertical" class="login-form" (ngSubmit)="confirmPassword()">
            <nz-form-item>
                <nz-form-control nzErrorTip="Please Enter your New Password!">
                    <nz-input-group [nzPrefix]="prefixLock">
                        <input autocomplete="off" [type]="newPasswordVisible ? 'text' : 'password'" id="pass" formControlName="enteredPassword" nz-input placeholder="Enter your New Password ">
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control nzErrorTip="Please Confirm Your New Password!">
                    <nz-input-group [nzPrefix]="prefixLock">
                        <input autocomplete="off" [type]="passwordVisible ? 'text' : 'password'" id="newPass" formControlName="confirmedPassword" nz-input placeholder="Confirm Your New Password ">
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item class="text-center">
                <nz-input-group>
                    <button nz-button nzType="primary" class="login-form-button ">Reset Password</button>
                </nz-input-group>
            </nz-form-item>
        </form>

        <ng-template #suffixTemplate>
            <i nz-icon [nzType]="passwordVisible ? 'eye' : 'eye-invisible'" (click)="passwordVisible = !passwordVisible"></i>
        </ng-template>
        <ng-template #newTemplate>
            <i nz-icon [nzType]="newPasswordVisible ? 'eye' : 'eye-invisible'" (click)="newPasswordVisible = !newPasswordVisible"></i>
        </ng-template>
        <!-- GET NEW PASSWORD -->

    </ng-container>
    <ng-template class="modal_footer" *nzModalFooter></ng-template>
</nz-modal>

<!-- Drawer -->



<!-- GET OTP MODAL ENDS -->